import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']

  connect() {
    this.loading = false
    this.reset = this.reset.bind(this)
    document.addEventListener('turbo:fetch-request-error', this.reset)
  }

  disconnect() {
    document.removeEventListener('turbo:fetch-request-error', this.reset)
  }

  load(event) {
    if (this.loading) {
      event.preventDefault()
      return
    }

    this.loading = true
    this.originalLabel = this.buttonTarget.textContent
    this.buttonTarget.textContent = 'Loading…'
    this.buttonTarget.setAttribute('aria-busy', 'true')
    this.buttonTarget.classList.add('is-loading')
  }

  reset() {
    if (!this.loading || !this.hasButtonTarget) return

    this.loading = false
    this.buttonTarget.textContent = this.originalLabel
    this.buttonTarget.removeAttribute('aria-busy')
    this.buttonTarget.classList.remove('is-loading')
  }
}
